import { render, staticRenderFns } from "./extendedApolloQuery.vue.html?vue&type=template&id=2c76595e&"
import script from "./extendedApolloQuery.ts?vue&type=script&lang=ts&"
export * from "./extendedApolloQuery.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports